import { memo } from 'react';

import type { VideoSectionProps } from '../types/video';

import IndividualVideoPlayer from './individual-video-player';

const VideoSection = memo(({ videoData, videoId }: VideoSectionProps) => {
  // Guard against invalid video data
  if (!videoData || !videoId || !videoData.src) {
    return null;
  }

  return (
    <div className="mb-6 explanation-box no-math">
      <div className="text-center mb-4">
        <h4 className="font-semibold text-primary text-lg">Watch & Learn</h4>
        <p className="text-xs sm:text-sm text-secondary">
          Video explanation for this exercise
        </p>
      </div>

      <IndividualVideoPlayer
        analyticsCategory="exercise"
        description={videoData.description}
        lazy={true}
        src={videoData.src}
        thumbnail={videoData.thumbnail}
        title={videoData.title}
        videoId={videoId}
      />
    </div>
  );
});

VideoSection.displayName = 'VideoSection';

export default VideoSection;
